// extracted by mini-css-extract-plugin
module.exports = {"trash":"trash___1_HVP"};